<template>
    <div class="pt-cats">
        <van-nav-bar :title="title" left-text="" @click-left="onClickLeft" left-arrow :fixed="true">
        </van-nav-bar>
        <div v-if="cats.length>0">
            <div class="ptc-bq">
                <van-tabs v-model="active" @click="toCat()">
                    <van-tab v-for="cat in cats" :title="cat.categoryName">
                    </van-tab>
                </van-tabs>
            </div>
            <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    @load="onLoad"
            >
                <div class="ptc-items">
                    <div class="ptc-item" v-for="spu in list" @click="toSpuDetails(spu.id)">
                        <img :src="spu.coverImg"
                             style="border-top-left-radius: 7px;border-top-right-radius: 7px"/>
                        <div style="display: flex;flex-direction: row;margin-top: 5px">
                            <div style="display:flex;flex-direction: column;width: 60%;padding-left: 8px;height: 75px;justify-content:center;">
                                <span style="height: 23px;line-height: 23px;font-size:13px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{{spu.spuName}}</span>
                                <span style="height: 20px;line-height: 20px;font-size: 11px;color:#D2D2D2;text-decoration: line-through;">原价: {{spu.costPrice}}</span>
                                <span style="height: 20px;line-height: 20px;font-size: 13px;color: #ff4d51">¥: {{spu.skuPrice}}</span>
                            </div>
                            <div style="display:flex;flex-direction: column;align-items: center;justify-content:center;width: 37%;">
                                <van-icon name="shopping-cart-o" style="font-size: 23px;margin-bottom: 2px"/>
                                <span style="font-size: 9px">已售 {{spu.salesVolume}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </van-list>
        </div>
    </div>
</template>

<script>
    import {getDeptId, getDeptName} from "../../utils/auth";

    export default {
        data() {
            return {
                title: '',
                deptId: '',
                catId: '',
                cats: [],

                active: 0,

                cId: '',
                list: [],
                loading: false,
                finished: false,
                page: 1,
            };
        },
        async created() {
            document.title = getDeptName()
            this.catId = this.$route.params.catId
            this.deptId = getDeptId()
            this.getTwoCats()
        },
        methods: {
            async getTwoCats() {
                let data = {
                    catId: this.catId,
                    catType: 0,
                }
                let res = await this.$get("/spm/getSpmTwoCats", data)
                this.title = res.catName
                this.cats = res.list
                if (res.list.length > 0) {
                    this.cats.unshift(res.cat)
                }
            },

            toCat() {
                let cat = this.cats[this.active]
                this.cId = cat.id
                this.list = []
                this.page = 0
                this.finished = false
                this.onLoad()
            },

            async onLoad() {
                let currentPage = this.page || 1;
                let data = {
                    catId: this.catId,
                    deptId: this.deptId,
                    categoryId: this.cId,
                    spuStatus: "0",
                    isShow: "0",
                    currentPage
                }
                let res = await this.$get("/spm/getSpmSpuPage", data)
                if (res.code == 200) {
                    const count =res.dataSet.list.length
                    const newList =res.dataSet.list
                    const list =this.list.concat(newList)
                    if (list.length<30){
                        this.list = this.quchong(list,"id")
                    }else {
                        this.list =list
                    }
                    this.page=this.page+1
                    this.loading = false
                    if (count<10&&count==0){
                        this.finished = true
                    }
                }else {
                    this.finished = true
                }
            },

            toSpuDetails(id) {
                this.$router.push('/spuDetails/' + this.deptId + '/' + id)
            },
            onClickLeft() {
                if (window.history.length > 1) {
                    this.$router.back();
                } else {
                    this.$router.push('/home/' + this.deptId)
                }
            },
        },
    };
</script>

<style lang="scss" scoped>

    .pt-cats {
        margin: 0 auto;
        height: 100%;
        padding-top: 78px;
    }

    .ptc-bq {
        margin-bottom: 5px;
        width: 100%;
        position: fixed;
        top: 47px;
        z-index: 999;
    }

    .ptc-items {
        display: flex;
        flex-flow: row wrap;
        font-size: 10px;
        padding: 0px 8px;
    }

    .ptc-item {
        box-sizing: border-box;
        margin: 8px 10px;
        display: flex;
        flex-direction: column;
        cursor: pointer;
        width: calc((100% - 40px) / 2); // 我这里一行显示4个 所以是/4  一行显示几个就除以几
        min-width: calc((100% - 40px) / 2);
        max-width: calc((100% - 40px) / 2);
    }

    .ptc-bq /deep/ .van-tabs--line {
        height: 32px;
    }

    .ptc-bq /deep/ .van-tabs__wrap {
        height: 32px;
    }

    .ptc-bq /deep/ .van-tab--active {
        color: #323233;
        font-weight: 500;
        font-size: 14px;
        width: 100px;
    }

</style>
